import {autorun, observable} from 'mobx';
import {NotificationObject} from './NotificationObject';
import {generateGuid} from '../utils/generateGuid';

export class NotificationStore {
    @observable _notifications: NotificationObject[] = [];

    public addNotification(notification: Omit<NotificationObject, 'id'>) {
        if (notification.type && notification.once) {
            if (this._notifications.findIndex((n) => n.type === notification.type) !== -1) {
                return;
            }
        }
        const id = generateGuid();
        const notificationWithId: NotificationObject = {
            ...notification,
            id
        }

        this._notifications.push(notificationWithId);

        if (notification.autoClose) {
            autorun(() => {
                this.removeNotification(id);
            }, { delay: 5000 });
        }
    }

    public get notifications(): NotificationObject[] {
        return this._notifications;
    }

    public removeNotification(id: string): void {
        this._notifications = this._notifications.filter((n: NotificationObject) => n.id !== id);
    }

    public clear(): void {
        this._notifications = [];
    }

    public removeNotificationByType(type: string): void {
        const index = this._notifications.findIndex(
            (notification: NotificationObject) => notification.type === type
        );

        if (index !== -1) {
            this._notifications.splice(index, 1);
        }
    }
}

export const notifications = new NotificationStore();
